import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map} from 'rxjs/operators';
import {of} from 'rxjs';
import {RegionCode} from '../../../services/api/account/regions/region.model';
import {
  loadOrganizationPersistentAddresses,
  loadOrganizationPersistentAddressesFailure,
  loadOrganizationPersistentAddressesSuccess
} from './organization-account.persistent-addresses.actions';
import {PersistentAddressesService} from '../../../services/api/account/persistent-addresses/persistent-addresses.service';
import {AvailablePersistentAddresses} from '../../../services/api/account/persistent-addresses/persistent-address.model';


@Injectable()
export class OrganizationAccountPersistentAddressesEffects {

  // noinspection JSUnusedGlobalSymbols
  loadOrganizationPersistentAddresses$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(loadOrganizationPersistentAddresses),
        concatMap((data: { region: RegionCode }) => {
            return this.service.getPersistentAddresses(data.region)
              .pipe(
                map((addresses: AvailablePersistentAddresses) =>
                  loadOrganizationPersistentAddressesSuccess({data: addresses})),
                catchError((error: unknown) =>
                  of(loadOrganizationPersistentAddressesFailure({error})))
              );
          }
        )
      );
  });


  constructor(
    private readonly actions$: Actions,
    private readonly service: PersistentAddressesService
  ) {
  }

}
